import { v4 as uuidv4 } from 'uuid';

import { MatchType } from '@frontend/types/workflow-agent';

/**
 * Generate a unique UUID for nodes
 */
export function generateNodeId(): string {
  return uuidv4();
}

/**
 * Generate a unique UUID for edges
 */
export function generateEdgeId(): string {
  return uuidv4();
}

/**
 * Extract the step ID from a node ID. Since we're using UUIDs,
 * this now simply returns the ID as-is.
 */
export function extractStepId(nodeId: string): string {
  return nodeId;
}

/**
 * Simple string hash function for deterministic IDs
 */
function simpleHash(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash).toString(36).substring(0, 12);
}

/**
 * Generate a deterministic condition node ID based on parent step ID and condition content
 */
export function generateConditionNodeId(
  parentStepId: string,
  condition: { matching_condition: string; match_type: MatchType }
): string {
  const contentString = `${condition.match_type}:${condition.matching_condition}`;
  const hash = simpleHash(contentString);
  return `${parentStepId}-condition-${hash}`;
}

/**
 * Check if a node is a nested step based on its data rather than ID prefixes.
 * This function now checks the node's parentId property.
 */
export function isNestedStep(nodeData?: { parentId?: string }): boolean {
  return Boolean(nodeData?.parentId);
}
